import { FormikErrors, useFormikContext } from 'formik';
import {
	ValueMappingOperators,
	ValueMappingOps,
	ValuemappingProfileFormShape,
} from '@Types/valuemappingForm.types';

import { InputAutocomplete } from '@innovyze/stylovyze';
import React from 'react';
import { t } from 'i18next';

export interface ValueMappingDataPointOperatorProps {
	field: string;
	index: number;
	errors: FormikErrors<ValuemappingProfileFormShape>;
}

export const ValueMappingDataPointOperator = ({
	index,
	errors,
}: ValueMappingDataPointOperatorProps) => {
	const { values } = useFormikContext<ValuemappingProfileFormShape>();
	const valueMappingOperatorOptions = Object.values(
		ValueMappingOperators,
	).map(e => ({
		key: e,
		value: e,
	}));
	return (
		<InputAutocomplete
			label={t('Operator')}
			options={valueMappingOperatorOptions}
			fieldAttrs={{
				name: `mappings[${index}].operator`,
				value: values.mappings[index]?.operator as ValueMappingOps,
				defaultValue: valueMappingOperatorOptions[0].value,
			}}
			helperText={
				(errors as Record<string, string>)[
					`mappings[${index}].operator`
				]
			}
			error={
				!!(errors as Record<string, string>)[
					`mappings[${index}].operator`
				]
			}
			dataCy={'datapoint-operator'}
		/>
	);
};

export default ValueMappingDataPointOperator;
